import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LANGUAGE } from '@constants';
import { getLocalStorage, setLocalStorage } from '../helpers';
import jp from './jp';
import en from './en';
const search = window.location.search;
const listPath = search ? search.slice(1, search.length).split('?') : '';
const isLanguage = listPath[0] === 'en' || listPath[0] === 'jp';
let language = isLanguage ? listPath[0] : LANGUAGE.EN;

if (getLocalStorage('LANGUAGE') && !isLanguage) {
  language = getLocalStorage('LANGUAGE');
} else {
  setLocalStorage('LANGUAGE', language);
}
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: language,
    fallbackLng: language,
    interpolation: {
      escapeValue: false,
    },
    lang: language,
    resources: {
      en,
      jp,
    },
  });

export default i18n;
